import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { currentStateState } from '../../../storage/client';
import CurrentStateSharedMarker from './CurrentStateSharedMarker';

type Props = {
  ident: string;
};

function CurrentStateMarker({ ident }: Props) {
  const currentState = useRecoilValue(currentStateState(ident));

  if (!currentState || (!currentState.asset.vehicle && !currentState.asset.assetType)) return null;

  return <CurrentStateSharedMarker currentState={currentState} />;
}

export default memo(CurrentStateMarker);
